import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { useNewbuildingPurchaseGiftPromo } from './NewbuildingPurchaseGiftPromoContext';
import { trackEntryPointShow } from './tracking';
import { NewbuildingPurchaseGiftHeaderLabel } from '../../components/NewbuildingPurchaseGiftHeaderLabel';
import { NEWBUILDING_PURCHASE_GIFT_HEADER_LABEL_TEXT } from '../../constants/newbuildingPurchaseGiftPromo';

export const NewbuildingPurchaseGiftHeaderLabelContainer: React.FC = () => {
  const { isAvailable, openModal } = useNewbuildingPurchaseGiftPromo();

  const handleShow = React.useCallback(() => trackEntryPointShow('header'), []);
  const handleClick = React.useCallback(() => openModal('header'), [openModal]);

  if (!isAvailable) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} triggerOnce wrapper={false}>
      <NewbuildingPurchaseGiftHeaderLabel text={NEWBUILDING_PURCHASE_GIFT_HEADER_LABEL_TEXT} onClick={handleClick} />
    </ActionAfterViewObserver>
  );
};
